import './App.css';
import Search from './Search';

function App() {
  return (
    <div className="App">
      <div className="container">
    
      <Search defaultKeyword="boy"/>
       <footer>Coded by Hellen Adhekon</footer>
       </div>
      </div>
  );
}

export default App;
